<script>
import {
  layoutMethods,
  billsPaymentMethods
} from "@/state/helpers";
import ImageUploader from "@/components/ImageUploader"
import Swal from "sweetalert2";
import { getModuleAccess } from '@/router/helper.js'

export default {
  page: {
    title: "Bills Payment Category",
  },
  data() {
    return {
      title: "Bills Payment Category",
      categoryId: 0,
      folder: 'biller-images-categories',
      categoryLogo: {
        filename: null,
        type: null,
        base64: null,
      },
      billsCategory: {
        categoryId: null,
        categoryStatus: null,
        categoryIconSrc: null,
        categoryCode: null,
        categoryDescription: null,
        // billsCategoryProvider: {},
        categorySequence: 0
      },
      formExitChecker: {
        categoryId: null,
        categoryStatus: null,
        categoryCode: null,
        categoryDescription: null,
        // billsCategoryProvider: {},
        categorySequence: 0,
      },
      formValidation: {
          categoryIcon: false,
          categoryDescription: false,
      },
      isSubmitted: false,
      formStatus:'',
      billsPaymentModule: {
        access: {
          update: true
        }
      },
      isUpdateForm:false,
    };
  },
  components: {
    ImageUploader
  },
  methods: {
    ...layoutMethods,
    ...billsPaymentMethods,
    async getDetails(){
      await this.actionBillsPaymentCategory({
          action: "details",
          body: {"categoryId":this.categoryId}
      })
      .then((res) => {
        console.log(res);
        this.isUpdateForm = true;
        this.billsCategory = {...res["message"]};
        console.log("this", this.billsCategory);
        this.formExitChecker = {...this.billsCategory};
      }).catch((e)=>{
        console.log("error while getting provider list",e);
      });
    },
    clearLogo() {
      this.categoryLogo = {
        filename: null,
        type: null,
        base64: null,
      };
    },
    checkForm() {
      this.formValidation.categoryIcon = false;
      this.formValidation.categoryDescription = false;
      var status = true;

      if(this.isEmpty(this.billsCategory.categoryDescription)){
        status = false;
        this.formValidation.categoryDescription = true;
      }
      // console.log(JSON.stringify(this.categoryLogo),JSON.stringify(this.billsCategory.categoryIconKey));
      if(this.isEmpty(this.categoryLogo.filename) && this.isEmpty(this.billsCategory.categoryIconKey)){
        status = false;
        this.formValidation.categoryIcon = true;
      }
      if(status){ 
        // console.log("hey");
        this.isSubmitted = true;
        this.formStatus = "Uploading Image...";
        this._updateCategory();
      }
    },
    _updateCategory() {
      var categoryObj = { ...this.billsCategory };
      if (this.categoryLogo.base64) {
        var categoryLogo = { ...this.categoryLogo };
        categoryLogo.folder = this.folder;

        this.uploadLogo(categoryLogo)
          .then((imageKey) => {
            categoryObj = {
              ...categoryObj,
              categoryIconKey: imageKey,
            };
            console.log(">> categoryObj: (Upload)",JSON.stringify(categoryObj));
            if(this.categoryId > 0) this.updateCategory(categoryObj);
            else this.insertCategory(categoryObj);

            
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        //categoryObj.categoryIcon = categoryObj.categoryIcon;
        if(this.categoryId > 0) this.updateCategory(categoryObj);
        else this.insertCategory(categoryObj);
      }
    },
    async insertCategory(categoryObj){
        await this.actionBillsPaymentCategory({
            action: "create",
            body: {...categoryObj}
        })
        .then((res) => {
          console.log("INSERT billsCategory",res);
          this.billsCategory = categoryObj;
          this.formExitChecker = categoryObj;
          this.clearLogo();
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Bills Payment Category",
            }
          );
        }).catch((e)=>{
          console.log("error while creating billsCategory",e);
        });//*/

        console.log("categoryObj",JSON.stringify(categoryObj));
        this.isSubmitted = false;
        this.formStatus = "";
    },
    async updateCategory(categoryObj) {
      this.formStatus = "Updating billsCategory...";
      console.log("categoryObj: ", categoryObj);
      await this.actionBillsPaymentCategory({
          action: "update",
          body: {...categoryObj}
      })
      .then((res) => {
        console.log(res);
        Swal.fire(
          "Update Successful!",
          `${categoryObj.categoryDescription} has been updated.`,
          "success"
        );
        this.formStatus = "";
        this.isSubmitted = false;
        this.billsCategory = categoryObj;
        this.formExitChecker = categoryObj;
        this.clearLogo();
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Bills Payment Category",
          }
        );
      }).catch((e)=>{
          Swal.fire(
            "Update Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${categoryObj.categoryDescription} was not updated.`,
            "error"
          );
          // this.clearLogo();
          this.formStatus = "";
          this.isSubmitted = false;
      });
    },
    leaveform(next){
        if(JSON.stringify(this.billsCategory) == JSON.stringify(this.formExitChecker) && this.categoryLogo["filename"] == null){
          next();
          return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
    },
  },
  async mounted() {
    this.categoryId = this.$route.params.categoryId;
    this.billsCategory.categoryId = this.categoryId = this.$route.params.categoryId;
    console.log("Mounted", this.billsCategory);
    this.changeTitle({
      title: (this.categoryId > 0 ? "Edit" : "Add") + " Bills Payment Category",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: 'Bills Payment Category', to: { name: 'Bills Payment Category'} },
        { text: "Details", to: { name: "Bills Payment Category Form" } }
      ],
    });

    // await this.getProvider();
    if(this.categoryId > 0){
      await this.getDetails();
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Category')
    .then((access) => this.billsPaymentModule.access = access);
  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
      // console.log("billsCategory::", JSON.stringify(this.billsCategory));
      // console.log("formExitChecker::", JSON.stringify(this.formExitChecker));
      // console.log("categoryLogo::", JSON.stringify(this.categoryLogo));
      
      if(JSON.stringify(this.billsCategory) != JSON.stringify(this.formExitChecker) || this.categoryLogo["filename"] != null){
        this.leaveform(next);
      }else{
        next();
      }
  }
};
</script>

<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              class="me-4"
              v-model="categoryLogo"
              :imageSrc="billsCategory.categoryIconSrc"
              :isRequired="formValidation.categoryIcon"
              :showDeleteButton="false"
            />
            <div
                v-if="formValidation.categoryIcon"
                style="color: #f34e4e;font-size: 87.5%;text-align: center;">
                Image is required.
            </div>
          </div>
          <!-- end of img upload-->
          
          
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="width: 620px">
                <div class="row">
                  <label v-if="!billsPaymentModule.access.update" class="form-label medium fw-bold text-danger">Note: Your access is limited. You cannot update a Bills Category.</label>
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                      <input
                        class="form-check-input"
                        v-model="billsCategory.categoryStatus"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Category Code</label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Code"
                      v-model="billsCategory.categoryCode"
                      :class="{
                          'is-invalid' : formValidation.categoryCode
                      }"
                    />
                      <!-- :disabled="true" -->
                    <div
                        v-if="formValidation.categoryCode"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div><!--end of billsCategory name-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Category Description<span style="color: red">*</span></label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Description"
                      v-model="billsCategory.categoryDescription"
                      :class="{
                          'is-invalid' : formValidation.categoryDescription
                      }"
                    />
                      <!-- :disabled="true" -->
                    <div
                        v-if="formValidation.categoryDescription"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div><!--end of billsCategory name-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Category Sequence</label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Sequence Number"
                      v-model="billsCategory.categorySequence"
                      :class="{
                          'is-invalid' : formValidation.categorySequence
                      }"
                    />
                      <!-- :disabled="true" -->
                    <div
                        v-if="formValidation.categorySequence"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div><!--end of billsCategory name-->

                  <div v-if="!isSubmitted" class="row">
                    <div class="col-md-6 mt-3">
                      <b-button :disabled="isUpdateForm ? !billsPaymentModule.access.update:!billsPaymentModule.access.create" variant="primary" class="w-sm w-100p" type="submit">{{isUpdateForm ? "Update" : "Save"}}</b-button>
                    </div>
                    <div class="col-md-6 mt-3">
                      <router-link :to="{ name: 'Bills Payment Category', params: {} }" class="tc-white">
                        <b-button variant="light" class="w-sm w-100p" type="button" >Cancel</b-button>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <p>{{ formStatus }}</p>
                  </div>
                </div><!-- end of row-->
              </div><!-- end of card body -->
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> 
    </ValidationObserver><!-- end of validation observer-->
    <!-- billsCategory Selection -->
    
    <!-- end billsCategory Select -->
  </div>
  <!-- end of row-->
</template>
